var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cassie-vertical-md"},[_c('BasicForm',{attrs:{"item":_vm.item,"name-key":_vm.nameKey},on:{"update:item":_vm.updateItem}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }